import type { RunStep } from '../../runHistory/runStepUtils';

/**
 * Returns whether a Conditional's step matched, or null if the step has no Conditional report.
 */
export function getConditionalRunStepSummary(step: RunStep): string | null {
  const report = step.report?.conditional;
  if (report === undefined) {
    return null;
  }
  return report.passed ? 'Matched' : "Didn't match";
}
